import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressComponent } from './progress.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UtilitiesModule } from '../utilities/utilities.module';


@NgModule({
  declarations: [ProgressComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    UtilitiesModule
  ],
  exports: [ProgressComponent]
})
export class ProgressModule { }
